var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 213,
    viewBox: "0 0 224 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.58 2.5022C131.291 -4.06487 155.379 3.08458 174.819 14.7678C195.396 27.1337 212.489 45.872 219.79 68.736C227.069 91.535 224.69 116.98 214.348 138.564C204.745 158.606 183.792 168.843 165.662 181.701C147.78 194.383 131.415 214.847 109.58 212.866C87.86 210.896 78.0803 184.967 60.4349 172.154C42.7862 159.339 16.226 157.534 6.49841 138.016C-3.52019 117.915 -1.83594 91.0425 10.7305 72.4263C22.6726 54.735 50.4269 59.4504 67.8544 47.1225C84.8969 35.0669 89.5967 8.54661 109.58 2.5022Z",
    fill: "#FFDCAE",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowVector);
export default __webpack_public_path__ + "static/media/yellowVector.9336b8f989cd365c684126bac658dd34.svg";
export { ForwardRef as ReactComponent };